import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import DNAImage from 'assets/images/DNA_min.webp'
import StaticPageTypography from 'components/staticPage/StaticPageTypography'
import StaticPageWrapper from 'components/staticPage/StaticPageWrapper'
import { useTranslation } from 'react-i18next'
import { useStaticStyles } from 'styles/shared.styles'

const NotFound = () => {
    const { t } = useTranslation('common')
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const { wrapper, imageWrapper, descriptionWrapper, imageStyle } =
        useStaticStyles()

    return (
        <StaticPageWrapper
            title={t('errors.404')}
            withContact={true}
            withHomeButton={true}
        >
            <Box className={wrapper}>
                <Box>
                    <Box className={imageWrapper}>
                        <img alt="dna" src={DNAImage} className={imageStyle} />
                    </Box>
                    <Box className={descriptionWrapper}>
                        <StaticPageTypography
                            variant={isLargeScreen ? 'h6' : 'subtitle2'}
                        >
                            {t('errors.notFound.description')}
                        </StaticPageTypography>
                    </Box>
                </Box>
            </Box>
        </StaticPageWrapper>
    )
}

export default NotFound
